import { TypedAudioNode } from "./_Base";
import { NodeParamsConfig } from "../utils/params/ParamsConfig";
class NullAudioParamsConfig extends NodeParamsConfig {
}
const ParamsConfig = new NullAudioParamsConfig();
export class NullAudioNode extends TypedAudioNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "null";
  }
  initializeNode() {
    this.io.inputs.setCount(1);
  }
  cook(inputContents) {
    const audioBuilder = inputContents[0];
    this.setAudioBuilder(audioBuilder);
  }
}
